import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import SessionHelper from "../helpers/SessionHelper";
import { LOGGING_IN, LOGGING_OUT } from "../configurations/Constants";

// NOTE: event listener just to perform action on other tabs with the storage key
window.addEventListener("storage", (event) => {
  if (event.key === LOGGING_OUT) {
    SessionHelper.cleanUpStorageKeys();
    window.location.reload();
  }
  if (event.key === LOGGING_IN) {
    window.location.reload();
  }
});

const PrivateRoute = ({ isStaffRoute = false }) => {
  const location = useLocation();

  const isAuthenticated = isStaffRoute
    ? SessionHelper.isStaffLoggedIn()
    : SessionHelper.isUserLoggedIn();

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate
      to={isStaffRoute ? "/well-test-form" : "/login"}
      state={{ from: location }}
      replace
    />
  );
};

export default PrivateRoute;
